import { BadgeIndianRupee, Gem, MonitorSmartphone, SearchCheck, Puzzle, Headphones } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const ITEMS = [
  { icon: BadgeIndianRupee, t: "Affordable Pricing", d: "Professional websites at budget-friendly rates." },
  { icon: Gem, t: "Premium Designs", d: "Beautiful and modern website layouts." },
  { icon: MonitorSmartphone, t: "Mobile Responsive", d: "Websites that look excellent on phones, tablets, and desktops." },
  { icon: SearchCheck, t: "SEO-Friendly", d: "Websites built with search engine best practices." },
  { icon: Puzzle, t: "Customised Solutions", d: "Designs tailored to individual business requirements." },
  { icon: Headphones, t: "Dedicated Support", d: "Friendly assistance throughout the website development process." },
];

export const WhyChoose = () => (
  <section id="why" data-testid="why-section" className="relative overflow-hidden py-24 sm:py-32">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-royal/10 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead align="center" eyebrow="Why Pratap Group" title={<>Why Businesses Choose <span className="text-gold-grad italic">Pratap Group</span></>} />
      <div className="mt-16 grid gap-px overflow-hidden rounded-3xl border border-white/[0.08] bg-white/[0.08] sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((it, i) => (
          <Reveal key={it.t} delay={i * 0.06} className="h-full">
            <div data-testid={`why-card-${i}`} className="group relative h-full bg-[var(--ink)] p-8 transition-colors duration-500 hover:bg-[var(--navy)] sm:p-10">
              <span className="font-display absolute right-8 top-6 text-6xl font-semibold text-white/[0.05] transition-colors duration-500 group-hover:text-gold/15">{String(i + 1).padStart(2, "0")}</span>
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[var(--royal)] to-[#1a3bb8] text-white shadow-[0_10px_40px_-10px_rgba(43,91,255,.7)] transition-transform duration-500 group-hover:-translate-y-1">
                <it.icon className="h-6 w-6" />
              </span>
              <h3 className="font-display mt-8 text-xl font-semibold text-white">{it.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{it.d}</p>
              <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[var(--gold)] to-transparent transition-[width] duration-700 group-hover:w-full" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
